import "./footer-button.css";
import PrimaryButton from "../PrimaryButton";
import OutlinedButton from "../OutlinedButton";

const FooterButton = ({
  submitButtonIcon,
  onSubmit,
  onBack,
  submitButtonTitle,
  backButtonTitle,
  disabledSubmit = false,
}) => {
  return (
    <div className="footer-button">
      <div className="footer-button-wrapper">
        {onBack && (
          <OutlinedButton onClick={onBack}>{backButtonTitle}</OutlinedButton>
        )}
        <PrimaryButton onClick={onSubmit && onSubmit} disabled={disabledSubmit}>
          {submitButtonIcon}
          {submitButtonTitle}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default FooterButton;
